export default __webpack_public_path__ + "images/45f89122468e6e7c5ed208639a1e34ad.svg";